import React, { useState, useEffect } from "react";
import axios from "axios"; // Import axios
import { Route, Routes } from "react-router-dom";
import { UserProvider } from "./contexts/UserContext"; // Import UserProvider

import LandingPage from "./views/LandingPage/LandingPage";
import AuthPage from "./views/AuthPage/AuthPage";
import ThreadsPage from "./views/ThreadsPage/ThreadsPage";
import Header from "./components/Header"; // Import the Header component
import "./App.css";

function App() {
  const url = `https://trend-maker-frontend.onrender.com/`; // Replace with your Render URL
  const interval = 300000; // Interval in milliseconds (30 seconds)

  function reloadWebsite() {
    axios
      .get(url)
      .then((response) => {
        console.log(
          `Reloaded at ${new Date().toISOString()}: Status Code ${
            response.status
          }`
        );
      })
      .catch((error) => {
        console.error(
          `Error reloading at ${new Date().toISOString()}:`,
          error.message
        );
      });
  }

  useEffect(() => {
    const intervalId = setInterval(reloadWebsite, interval);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  return (
    <UserProvider>
      <div className="app">
        <Header />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/threads" element={<ThreadsPage />} />
          </Routes>
        </div>
      </div>
    </UserProvider>
  );
}

export default App;
